(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const setup = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const find = selector => root.querySelector(selector);
    const cards = [...root.querySelectorAll('[data-location]')];
    const input = find('[data-search]');
    const clear = find('[data-clear]');
    const count = find('[data-count]');
    const empty = find('[data-empty-results]');
    const frame = find('[data-map-iframe]');
    const frameWrap = find('[data-map-frame]');
    const mapEmpty = find('[data-map-empty]');
    const mapName = find('[data-map-name]');
    const mapAddress = find('[data-map-address]');
    const mapLink = find('[data-map-link]');
    const mapBottom = find('[data-map-bottom]');
    const mapPanel = find('[data-map-panel]');
    const toggle = find('[data-map-toggle]');
    const filters = find('[data-filters]');
    let state = '';
    let selected = null;
    let visible = cards;
    let timer;
    const states = [...new Set(cards.map(card => card.dataset.state).filter(Boolean))];
    const setCount = number => {
      count.textContent = (number === 1 ? root.dataset.countOne : root.dataset.countMany).replace('{count}', number);
    };
    const select = card => {
      selected = card;
      cards.forEach(item => {
        const chosen = item === card;
        item.classList.toggle('is-selected', chosen);
        const button = item.querySelector('[data-show-map]');
        if (button) {
          button.setAttribute('aria-pressed', String(chosen));
          button.textContent = chosen ? root.dataset.selectedLabel : root.dataset.showLabel;
        }
      });
      const hasMap = !!card?.dataset.embed;
      frameWrap.hidden = !hasMap;
      mapEmpty.hidden = hasMap;
      mapBottom.hidden = !card;
      mapName.textContent = card ? card.dataset.name : root.dataset.mapHeading;
      mapAddress.textContent = card ? card.dataset.address : '';
      mapEmpty.querySelector('h3').textContent = card ? root.dataset.noAddressHeading : root.dataset.noResultsHeading;
      mapEmpty.querySelector('p').textContent = card ? root.dataset.noAddressText : root.dataset.noResultsText;
      if (hasMap) {
        const url = new URL(card.dataset.embed);
        if (url.protocol === 'https:' && url.hostname === 'www.google.com' && url.pathname === '/maps/embed') {
          if (frame.getAttribute('src') !== url.href) frame.setAttribute('src', url.href);
          frame.title = root.dataset.mapTitle.replace('{name}', card.dataset.name);
        }
      }
      if (card) {
        mapLink.href = card.dataset.directions || card.dataset.website;
        mapLink.querySelector('span').textContent = card.dataset.directions ? root.dataset.directionsLabel : root.dataset.websiteLabel;
      }
    };
    const update = () => {
      const query = normalize(input.value);
      const code = /^[a-z]{2}$/.test(query) && states.includes(query.toUpperCase());
      visible = cards.filter(card => {
        const stateMatches = !state || card.dataset.state === state;
        const queryMatches = !query || (code ? card.dataset.state === query.toUpperCase() : normalize(card.dataset.search).includes(query));
        card.hidden = !(stateMatches && queryMatches);
        return !card.hidden;
      });
      clear.hidden = !input.value;
      setCount(visible.length);
      empty.hidden = visible.length > 0;
      if (!selected || !visible.includes(selected)) select(visible[0] || null);
    };
    const createFilter = (value, label, number) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'yl-filter';
      button.setAttribute('aria-pressed', String(value === state));
      button.append(document.createTextNode(label));
      const badge = document.createElement('span');
      badge.textContent = number;
      badge.setAttribute('aria-hidden', 'true');
      button.append(badge);
      button.addEventListener('click', () => {
        clearTimeout(timer);
        state = value;
        [...filters.children].forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        update();
      });
      return button;
    };
    filters.append(createFilter('', root.dataset.allLabel, cards.length));
    states.forEach(value => {
      const card = cards.find(item => item.dataset.state === value);
      filters.append(createFilter(value, card.dataset.stateName, cards.filter(item => item.dataset.state === value).length));
    });
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(update, 180);
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); clearTimeout(timer); update(); }
      if (event.key === 'Escape') { input.value = ''; clearTimeout(timer); update(); }
    });
    clear.addEventListener('click', () => { input.value = ''; clearTimeout(timer); update(); input.focus(); });
    find('[data-reset]').addEventListener('click', () => {
      clearTimeout(timer);
      state = '';
      input.value = '';
      [...filters.children].forEach((item, index) => item.setAttribute('aria-pressed', String(index === 0)));
      update();
      input.focus();
    });
    const toggleMap = show => {
      root.classList.toggle('is-map-collapsed', !show);
      toggle.setAttribute('aria-expanded', String(show));
      toggle.querySelector('span').textContent = show ? root.dataset.hideMapLabel : root.dataset.showMapLabel;
    };
    toggle.addEventListener('click', () => toggleMap(toggle.getAttribute('aria-expanded') !== 'true'));
    root.querySelectorAll('[data-show-map]').forEach(button => button.addEventListener('click', () => {
      select(button.closest('[data-location]'));
      toggleMap(true);
      if (window.matchMedia('(max-width:760px)').matches) {
        mapPanel.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block:'start'});
      }
    }));
    root.querySelectorAll('[data-enhancement]').forEach(item => item.hidden = false);
    toggleMap(!window.matchMedia('(max-width:760px)').matches);
    update();
  };
  const init = () => document.querySelectorAll('[data-stockist-directory]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
